import React from 'react';
import { cn } from '@/lib/utils';

interface MapEmbedProps {
  address: string;
  height?: number;
  className?: string;
  zoom?: number;
}

const MapEmbed: React.FC<MapEmbedProps> = ({ address, height = 250, className, zoom = 15 }) => {
  const src = `https://www.google.com/maps?q=${encodeURIComponent(address)}&z=${zoom}&output=embed`;

  return (
    <div className={cn('w-full rounded-[20px] overflow-hidden shadow-[0_4px_16px_0_rgba(0,0,0,0.08)]', className)} style={{ height }}>
      <iframe
        title={`Mapa - ${address}`}
        src={src}
        width="100%"
        height="100%"
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export { MapEmbed, type MapEmbedProps };
export default MapEmbed;


